export default {
  TweetListPage: {
    scrollTop: {
      myimgs: 0,
      favs: 0,
      stocks: 0
    },
    listType: ''
  },
  flash: {
    msg: null
  }
}



// WEBPACK FOOTER //
// ./src/store/state.js